import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListNameCell } from './charge-point-list-name.cell';
import { ChargePointListNameHeader } from './charge-point-list-name.header';

export const ChargePointListNameColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['name']
> = {
  enableSorting: false,
  header: ChargePointListNameHeader,
  cell: ChargePointListNameCell,
  meta: { maxWidth: '140px' },
};
